import { DayPeriodTypeEnum } from "@/generated/openapi"
import { SortOptions } from "@/models/SortOptions"

function parseDayPeriodTypeEnum(str: string) {
  return DayPeriodTypeEnum.WorkingDay === str ? DayPeriodTypeEnum.WorkingDay : DayPeriodTypeEnum.Day
}

function asSortString(sortOptions: SortOptions): string|undefined {
  if (sortOptions.sortBy.length < 1) {
    return undefined
  }
  return sortOptions.sortBy.map(sortKey => `${sortKey}:${sortOptions.sortOrder.toUpperCase()}`).join(',')
}

export {
  parseDayPeriodTypeEnum,
  asSortString
}
